<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CONTRAT_SALARIE')">
        <slot name="section-contrat-salarie">
          <section-contrat-salarie ref="CONTRAT_SALARIE"
                                   id="CONTRAT_SALARIE"
                                   :extended="isExtended('CONTRAT_SALARIE')"
                                   :showButton="true"
                                   :autoSave="true"
                                   :readOnly="readOnly"
                                   :moduleId="moduleId"
                                   :searchText="searchText"
                                   :ressourceHeader="ressource"
                                   :fiche="fiche"
                                   :toggleResetEmploiSelect="toggleResetEmploiSelect"
                                   :toggleResetConventionClauseMiroir="toggleResetConventionClauseMiroir"
                                   :contrat=selectedContrat
                                   :route="route"
                                   :attribut="attribut"
                                   @extended="setExtended"
                                   @fullscreen="setFullscreen"
                                   @status="updateStatus"
                                   @updated="contratUpdated"
                                   @selectItem = "selectItem">
          </section-contrat-salarie>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CRENEAUX')">
        <slot name="section-creneaux">
          <section-creneaux ref="CRENEAUX"
                            id="CRENEAUX"
                            :extended="isExtended('CRENEAUX')"
                            :showButton="true"
                            :autoSave="true"
                            :readOnly="readOnly"
                            :moduleId="moduleId"
                            :searchText="searchText"
                            :ressourceHeader="ressource"
                            :fiche="fiche"
                            :toggleResetActiviteSelect="toggleResetActiviteSelect"
                            :contrat=selectedContrat
                            :route="route"
                            :attribut="attribut"
                            @extended="setExtended"
                            @fullscreen="setFullscreen"
                            @status="updateStatus"
                            @updated="creneauUpdated"
                            @selectItem = "selectItem">
          </section-creneaux>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('REMUNERATION')">
        <slot name="section-remuneration">
          <section-remuneration ref="REMUNERATION"
                                id="REMUNERATION"
                                :extended="isExtended('REMUNERATION')"
                                :showButton="true"
                                :autoSave="true"
                                :readOnly="readOnly"
                                :moduleId="moduleId"
                                :searchText="searchText"
                                :ressourceHeader="ressource"
                                :fiche="fiche"
                                :toggleResetRubriqueSelect="toggleResetRubriqueSelect"
                                :contrat=selectedContrat
                                :route="route"
                                :attribut="attribut"
                                @extended="setExtended"
                                @fullscreen="setFullscreen"
                                @status="updateStatus"
                                @updated="contratUpdated"
                                @selectItem = "selectItem">
          </section-remuneration>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('AFFILIATION_PROCESS')">
        <slot name="section-affiliation-process">
          <section-affiliation-process ref="AFFILIATION_PROCESS"
                                       id="AFFILIATION_PROCESS"
                                       :extended="isExtended('AFFILIATION_PROCESS')"
                                       :showButton="true"
                                       :autoSave="true"
                                       :readOnly="readOnly"
                                       :moduleId="moduleId"
                                       :searchText="searchText"
                                       :ressourceHeader="ressource"
                                       :fiche="fiche"
                                       :contrat=selectedContrat
                                       :route="route"
                                       :attribut="attribut"
                                       @extended="setExtended"
                                       @fullscreen="setFullscreen"
                                       @status="updateStatus"
                                       @updated="contratUpdated"
                                       @selectItem = "selectItem">
          </section-affiliation-process>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('CONTRAT')">
        <slot name="section-contrat">
          <section-contrat ref="CONTRAT"
                           id="CONTRAT"
                           :extended="isExtended('CONTRAT')"
                           :showButton="true"
                           :autoSave="true"
                           :readOnly="readOnly"
                           :moduleId="moduleId"
                           :searchText="searchText"
                           :ressourceHeader="ressource"
                           :fiche="fiche"
                           :toggleResetContratTemplateSelect="toggleResetContratTemplateSelect"
                           :contrat=selectedContrat
                           :route="route"
                           :attribut="attribut"
                           @extended="setExtended"
                           @fullscreen="setFullscreen"
                           @status="updateStatus"
                           @updated="contratUpdated"
                           @selectItem = "selectItem">
          </section-contrat>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('DPAE')">
        <slot name="section-dpae">
          <section-dpae ref="DPAE"
                        id="DPAE"
                        :extended="isExtended('DPAE')"
                        :showButton="true"
                        :autoSave="true"
                        :readOnly="readOnly"
                        :moduleId="moduleId"
                        :searchText="searchText"
                        :ressourceHeader="ressource"
                        :fiche="fiche"
                        :contrat=selectedContrat
                        :route="route"
                        :attribut="attribut"
                        @extended="setExtended"
                        @fullscreen="setFullscreen"
                        @status="updateStatus"
                        @updated="contratUpdated"
                        @selectItem = "selectItem">
          </section-dpae>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('PAIES')">
        <slot name="section-paies">
          <section-paies ref="PAIES"
                         id="PAIES"
                         :extended="isExtended('PAIES')"
                         :showButton="true"
                         :autoSave="true"
                         :readOnly="readOnly"
                         :moduleId="moduleId"
                         :searchText="searchText"
                         :ressourceHeader="ressource"
                         :fiche="fiche"
                         :contrat=selectedContrat
                         :route="route"
                         :attribut="attribut"
                         @extended="setExtended"
                         @fullscreen="setFullscreen"
                         @status="updateStatus"
                         @updated="paieUpdated"
                         @selectItem = "selectItem">
          </section-paies>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Contrat from '@/extend/classes/Contrat';
import Creneau from '@/extend/classes/Creneau';
import { storeCreneau } from '@/generated/stores';
import Paie from '@/extend/classes/Paie';
import { storePaie } from '@/generated/stores';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionContratSalarie from '@/custom/sections/SectionContratSalarie.vue';
import SectionCreneaux from '@/custom/sections/SectionCreneaux.vue';
import SectionRemuneration from '@/custom/sections/SectionRemuneration.vue';
import SectionAffiliationProcess from '@/custom/sections/SectionAffiliationProcess.vue';
import SectionContrat from '@/custom/sections/SectionContrat.vue';
import SectionDpae from '@/custom/sections/SectionDpae.vue';
import SectionPaies from '@/custom/sections/SectionPaies.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionContratSalarie,
    SectionCreneaux,
    SectionRemuneration,
    SectionAffiliationProcess,
    SectionContrat,
    SectionDpae,
    SectionPaies,
    FicheHeader,
  },

  props: {
    contrat: {
      type: Object as PropType<Contrat>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.PROJET_CONTRATS,
      sections: [
        'CONTRAT_SALARIE',
        'CRENEAUX',
        'REMUNERATION',
        'AFFILIATION_PROCESS',
        'CONTRAT',
        'DPAE',
        'PAIES',
      ],

      toggleResetEmploiSelect: false,
      toggleResetConventionClauseMiroir: false,
      creneau: new Creneau(),
      toggleResetActiviteSelect: false,
      toggleResetRubriqueSelect: false,
      toggleResetContratTemplateSelect: false,
      paie: new Paie(),
    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_PROJET_CONTRATS);
    },

    selectedContrat (): Contrat {
      return this.contrat
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    contratUpdated (contrat: Contrat) {
    // To implement
    },

    // eslint-disable-next-line
    creneauUpdated (creneau: Creneau) {
    // To implement
    },

    // eslint-disable-next-line
    paieUpdated (paie: Paie) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.contrat || this.contrat.id < 0) && value == 'CONTRAT_SALARIE') {
        this.setExtended(new Extended('CONTRAT_SALARIE', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
